<div class="overview-container">
  <mp-overview-card *ngIf="hatHeizung" [werteSammlung]="werte?.heizung" [overviewTypeConfig]="overviewTypeHeizung"></mp-overview-card>
  <mp-overview-card *ngIf="hatWarmwasser" [werteSammlung]="werte?.warmwasser" [werteSammlung2]="werte?.warmwasserM3" [overviewTypeConfig]="overviewTypeWarmwasser"></mp-overview-card>
  <mp-overview-card *ngIf="hatKaltwasser" [werteSammlung]="werte?.kaltwasser" [overviewTypeConfig]="overviewTypeKaltwasser"></mp-overview-card>
</div>
